<template>
  <div id="printable_statement" class="account-statement-page">
    <div class="header-bar">
      <h2>📄 Account Statement</h2>
      <div class="filters">
        <label>From:</label>
        <input type="date" v-model="startDate" />
        <label>To:</label>
        <input type="date" v-model="endDate" />
        <button class="exclude-print" @click="fetchStatement">Fetch</button>
        <button
          class="exclude-print"
          @click="
            printDiv('printable_statement', 'statement_' + current_account_id)
          "
        >
          📄 Print
        </button>
      </div>
    </div>

    <div
      v-if="loading"
      style="color: black; font-weight: 1.6em"
      class="centered"
    >
      Loading statement...
    </div>

    <div v-else-if="statement.length" class="statement-table">
      <!-- <div class="balance-bar">
        <strong>Current Balance: ₦{{ formatAmount(accountBalance) }}</strong>
      </div> -->
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Date</th>
            <th>Type</th>
            <th>Amount (Ksh)</th>
            <th>Description</th>
            <th>Note</th>
            <th>Balance After (Ksh)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in statement" :key="item.id">
            <td>{{ index + 1 }}</td>
            <td>{{ formatDate(item.created_at) }}</td>
            <td>
              {{
                item.destination_account_id == current_account_id
                  ? "Credit"
                  : "Debit"
              }}
            </td>
            <td>{{ formatAmount(item.amount) }}</td>
            <td>{{ item.description }}</td>
            <td>{{ item.user_note }}</td>
            <td>
              {{
                item.destination_account_id == current_account_id
                  ? item.destination_balance_after
                  : item.source_balance_after
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else class="centered">
      No transactions found for this date range.
    </div>
  </div>
</template>

<script>
import printPDF from "../../prints/div_to_pdf";
import { generalApiRequest } from "../../api/apiIndex";
export default {
  name: "AccountStatementPage",
  data() {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    return {
      startDate: firstDay.toISOString().substr(0, 10),
      endDate: today.toISOString().substr(0, 10),
      statement: [],
      accountBalance: 0,
      loading: false,
      current_account_id: this.$route.params.accountID,
    };
  },
  methods: {
    printDiv(id, name) {
      return printPDF(id, name);
    },
    async fetchStatement() {
      this.loading = true;

      var all_req_body = {
        account_id: this.current_account_id,
        start_date: this.startDate,
        end_date: this.endDate,
      };
      const all_url = `get_account_statement`;
      const all_res = await generalApiRequest(all_url, "GET", all_req_body, 1);
      this.statement = all_res.data;
      //   console.log(all_res.data);
      this.loading = false;
    },
    formatDate(date) {
      const d = new Date(date);
      return d.toLocaleDateString() + " " + d.toLocaleTimeString();
    },
    formatAmount(amount) {
      return parseFloat(amount).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
  mounted() {
    this.fetchStatement();
  },
};
</script>

<style scoped>
.account-statement-page {
  margin-top: 1.5em;
  padding: 20px;
  background-color: #fff;
  border: 1px solid black;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 15px;
}

.filters {
  display: flex;
  align-items: center;
  gap: 8px;
}

input[type="date"],
button {
  padding: 5px 10px;
  font-size: 0.9rem;
  border-radius: 4px;
  border: 1px solid #ccc;
}

button {
  background: #007bff;
  color: #fff;
  border: none;
  cursor: pointer;
}

button:hover {
  background: #0069d9;
}

.balance-bar {
  margin: 10px 0;
  font-size: 1.05rem;
  color: #333;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 5px;
}

table th,
table td {
  border: 1px solid #ddd;
  padding: 5px 8px;
  text-align: left;
  font-size: 0.85rem;
}

table th {
  background: #f4f4f4;
}

.centered {
  text-align: center;
  padding: 20px;
  font-size: 1rem;
}
</style>
